import type { ErrorEvent } from '@sentry/core';
import * as Sentry from '@sentry/react-native';
import { isRunningInExpoGo } from 'expo';

import { SENTRY_DSN, ANONYMIZED_VALUE } from '@/tracking/constants/sentry';

export const navigationIntegration = Sentry.reactNavigationIntegration({
  enableTimeToInitialDisplay: !isRunningInExpoGo()
});

if (process.env.EXPO_PUBLIC_SENTRY_ENABLED === 'true' && SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    sendDefaultPii: false,
    sendClientReports: false,
    sampleRate: 0.15,
    tracesSampleRate: __DEV__ ? 1 : 0,
    // TODO: Enable traces in production (e.g., 0.1-0.2) after testing
    profilesSampleRate: __DEV__ ? 1 : 0,
    maxBreadcrumbs: 200,
    enableCaptureFailedRequests: true,
    integrations: [navigationIntegration],
    enableNativeFramesTracking: !isRunningInExpoGo(),
    beforeSend: (event: ErrorEvent) => {
      if (event.contexts?.device) {
        event.contexts.device.name = ANONYMIZED_VALUE;
        event.contexts.device.device_unique_identifier = ANONYMIZED_VALUE;
      }
      if (event.user && event.user.id) {
        event.user.id = ANONYMIZED_VALUE;
      }
      return event;
    },
    debug: false
  });
} else if (process.env.EXPO_PUBLIC_SENTRY_ENABLED === 'true') {
  console.warn('Sentry DSN not configured - tracking disabled');
}
